mutation updateAiSettings($input: AiSettingsInput!) {
  updateAiSettings(input: $input) {
    formality
    perspective
    targetGroup
    tonality
    contentCreatorSettings {
      useLinks
      useHashtags
    }
  }
}
